import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Subject, Subscription } from 'rxjs';
import { ConsentParams } from '../../cil/energy/energy-activate-consent/energy-activate-consent.component';
import { PublicState } from '../../state/public.state';

@Component({
  selector: 'cil-consent-energy',
  templateUrl: './consent-energy.component.html',
  styleUrls: ['./consent-energy.component.scss'],
  standalone: false,
})
export class ConsentEnergyComponent {
  private _subscriptions: Subscription[] = [];
  public consentInfo$ = inject(Store).selectSignal(PublicState.consentInfo);
  public params: ConsentParams;

  constructor(private readonly router: Router) {
    effect(() => {
      const consentInfo = this.consentInfo$();

      if (consentInfo) {
        if (consentInfo.user.isActive) {
          this.router.navigate([`/app/properties/${consentInfo.property.id}/energies`]);

          return;
        }

        const { property, user, nrjType, token } = consentInfo;
        this.params = {
          property,
          loggedUser: user,
          nrjType,
          sub: new Subject<void>(),
          isNewUser: false,
          step: 1,
          token,
        };
      }
    });
  }

  public end(): void {
    window.close();
  }

  public ngOnDestroy(): void {
    for (const sub of this._subscriptions) {
      sub.unsubscribe();
    }
  }
}
